import { PostStatDto, PostStatModel } from '../../data-layer/posts/types';

export const toPostStatisticModel = (postStatDto: PostStatDto): PostStatModel => ({
    coverage: postStatDto.coverage,
    involved: postStatDto.involved,
    shows: postStatDto.shows,
    showsInGrid: postStatDto.shows_in_grid,
    subscribers: postStatDto.subscribers,
    interactions: postStatDto.interactions,
});
